import styled from 'styled-components';
import {ButtonBase} from "@mui/material";

export const LicenseAdminActivationContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2rem;
`;

export const LicenseActivationForm = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    text-align: left;
    width: 100%;
`;

export const DragDropArea = styled(ButtonBase)<{ $isDragging?: boolean }>`
    && {
        flex: 1;
        padding: 32px;
        box-sizing: border-box;
        background: ${({ $isDragging, theme }) => (
    $isDragging
        ? theme.palette.action.hoveredDropzone
        : theme.palette.background.dropzone
)};
        
        border-radius: 24px;
        border: 2px dashed ${({ $isDragging, theme }) => (
    $isDragging
        ? theme.palette.dividers.strong
        : theme.palette.divider
)};
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        transition: all 0.2s ease;
        width: 100%;

        &:hover {
            background: ${({ theme }) => theme.palette.action.hoveredDropzone };
            border-color: ${({ theme }) => theme.palette.dividers.strong};
        }
    }
`;

export const IconCircle = styled.div`
    width: 64px;
    height: 64px;
    background: ${({ theme }) => theme.palette.background.paper};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.palette.dividers.default};
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
    
    svg {
        width: 28px;
        height: 28px;
    }
`;

export const FileList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 10px 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    gap: 12px;
    
    li {
        color: ${({theme}) => theme.palette.text.primary};
        font-size: ${({theme}) => theme.typography.body2.fontSize};
    }

    button {
        background: none;
        border: none;
        cursor: pointer;
        font-weight: ${({theme}) => theme.typography.button.fontWeight};
        color: ${({theme}) => theme.palette.text.primary};
        font-size: ${({theme}) => theme.typography.body2.fontSize};
    
        &:hover {
            color: ${({theme}) => theme.palette.action.delete};
        }
    }
`;